import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=8e1e7422&scoped=true&"
import script from "./Comprehensive.vue?vue&type=script&lang=js&"
export * from "./Comprehensive.vue?vue&type=script&lang=js&"
import style0 from "./Comprehensive.vue?vue&type=style&index=0&id=8e1e7422&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1e7422",
  null
  
)

export default component.exports